module.exports = __webpack_public_path__ + "static/media/contact-lawyers.4fcbf0be.gif";